import * as React from 'react';

export const NavigationListContext = React.createContext(false);

export function useNavigationListContext(partName: string): void {
  const context = React.use(NavigationListContext);

  if (!context) {
    throw new Error(`${partName} must be used within NavigationList.Root`);
  }
}
